const getRunning = (state) => {
  return Array.isArray(state.running) ? state.running : []
}

const hasSimulation = (state) => {
  return true // state.has_simulation
}

export { getRunning, hasSimulation }
